import axios from 'axios';

const state = {
    user: null,

    userAdvertsTotal: {},
    selectedAgentUuid: '',

    userAgents: [],
    filteredUserAgents: [],
    userAgentsTotal: {},

    userFavoritesTotals: {},

    userAdAlertsTotal: null,
};

const getters = {

};

const actions = {
    getUserAgents({ commit }) {
        return axios.get('/api/user/agents')
            .then(async ({ data }) => {
                await commit('setUserAgents', data.data);
                commit('setUserAgentsTotal');
            });
    },
    async filterUserAgents({ commit }, payload) {
        await commit('setFilteredUserAgents', payload);
        commit('setUserAgentsTotal');
    },
    setUserFavorite({ commit }, slug) {
        return axios.post(`/api/user/set-favorite/${slug}`)
            .then(({ data }) => data)
            .then(async ({ data }) => {
                commit('updateUserFavoritesTotals', data);
                return data;
            });
    },
    unsetUserFavorite({ commit }, slug) {
        return axios.post(`/api/user/unset-favorite/${slug}`)
            .then(({ data }) => data)
            .then(async ({ data }) => {
                commit('updateUserFavoritesTotals', data);
                return data;
            });
    },
    saveGetAlerts({ commit }, formData) {
        const { slug } = formData;
        return axios.post(`/api/user/save-ad-alerts/${slug}`, formData)
            .then(async ({ data }) => {
                commit('setUserAdAlertsTotal', data.count_alerts);
                return data;
            });
    },
    publishAd({ commit }, slug) {
        return axios.patch(`/api/user/adverts/${slug}/publish`)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    renewAd({ commit }, slug) {
        return axios.patch(`/api/user/adverts/${slug}/renew`)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    unpublishAd({ commit }, formData) {
        const { slug } = formData;
        return axios.patch(`/api/user/adverts/${slug}/unpublish`, formData)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    letAgreedAd({ commit }, formData) {
        const { slug } = formData;
        return axios.patch(`/api/user/adverts/${slug}/let-agreed`, formData)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    deleteAd({ commit }, slug) {
        return axios.delete(`/api/user/adverts/${slug}/delete`)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await commit('addToUserAdvertsTotal', -1);
                return data;
            });
    },
    moveAd({ commit }, formData) {
        const { slug } = formData;
        return axios.patch(`/api/user/adverts/${slug}/move`, formData)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    bulkPublishAdverts({ commit }, slugs) {
        return axios.patch('/api/user/adverts/bulk-publish', { slugs })
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    bulkUnpublishAdverts({ commit }, formData) {
        return axios.patch('/api/user/adverts/bulk-unpublish', formData)
            .then((res) => res.data)
            .then(async ({ data }) => data);
    },
    bulkLetAgreedAdverts({ commit }, slugs) {
        return axios.patch('/api/user/adverts/bulk-let-agreed', { slugs })
            .then((res) => res.data)
            .then(async ({ data }) => data);
    },
    bulkDeleteAdverts({ commit }, formData) {
        return axios.delete('/api/user/adverts/bulk-delete', { data: formData })
            .then((res) => res.data)
            .then(async ({ data }) => {
                data.forEach(async (advert) => {
                    await commit('addToUserAdvertsTotal', -1);
                });
                return data;
            });
    },
    bulkMoveAdverts({ commit }, formData) {
        return axios.patch('/api/user/adverts/bulk-move', formData)
            .then((res) => res.data)
            .then(({ data }) => data);
    },
    enableAgent({ commit }, formData) {
        const { uuid } = formData;
        return axios.patch(`/api/user/${uuid}/enable`, formData)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await commit('updateUserAgent', data);
                commit('setUserAgentsTotal');
            });
    },
    disableAgent({ dispatch }, formData) {
        const { uuid } = formData;
        return axios.patch(`/api/user/${uuid}/disable`, formData)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await dispatch('getUserAgents');
            });
    },
    deleteAgent({ commit, dispatch }, formData) {
        const { uuid } = formData;
        return axios.delete(`/api/user/${uuid}/delete`, { data: formData })
            .then((res) => res.data)
            .then(async ({ data }) => {
                await dispatch('getUserAgents');
                await commit('addToUserAgentsTotal', -1);
            });
    },
    updateAgentSettings({ commit }, formData) {
        const { uuid } = formData;
        return axios.patch(`/api/user/${uuid}/agent-settings`, formData)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await commit('updateUserAgent', data);
            });
    },
    updateCompanySettings({ commit }, formData) {
        const { uuid } = formData;
        return axios.patch(`/api/user/${uuid}/company-settings`, formData)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await commit('setUser', data);
            });
    },
    uploadAvatar({ commit }, formData) {
        return axios.post('/api/user/avatar', formData)
            .then((res) => res.data)
            .then(({ data }) => {
                commit('setUser', data);
            });
    },
    deleteAdAlert({ commit }, id) {
        return axios.delete(`/api/user/alerts/${id}`)
            .then((res) => res.data)
            .then(({ data }) => {
                commit('addToUserAdAlertsTotal', -1);
                return data;
            });
    },
    updateAdAlert({ commit }, formData) {
        const { id } = formData;
        return axios.patch(`/api/user/alerts/${id}`, formData)
            .then((res) => res.data);
    },
    moveChat({ commit }, formData) {
        const { conversationSid } = formData;
        return axios.post(`/api/chat/conversations/${conversationSid}/move`, formData)
            .then((res) => res.data);
    },
};

const mutations = {
    setUser(state, payload) {
        state.user = payload;
    },
    setUserAdvertsTotal(state, payload) {
        state.userAdvertsTotal = payload;
    },
    setUserAgents(state, payload) {
        state.userAgents = payload;
    },
    setUserAgentsTotal(state) {
        state.userAgentsTotal = {
            all: {
                count: 0,
            },
            active: {
                count: 0,
            },
            inactive: {
                count: 0,
            },
        };
        state.userAgents.forEach((agent) => {
            state.userAgentsTotal.all.count += 1;
            if (agent.is_active) {
                state.userAgentsTotal.active.count += 1;
            } else {
                state.userAgentsTotal.inactive.count += 1;
            }
        });
    },
    setFilteredUserAgents(state, payload) {
        const { active } = payload;
        state.filteredUserAgents = state.userAgents.filter((agent) => agent.is_active === (active === 'active'));
    },
    updateUserAgent(state, payload) {
        state.userAgents = state.userAgents.map((agent) => {
            if (agent.uuid === payload.uuid) {
                return payload;
            }
            return agent;
        });
        state.filteredUserAgents = state.filteredUserAgents.map((agent) => {
            if (agent.uuid === payload.uuid) {
                return payload;
            }
            return agent;
        });
    },
    deleteUserAgent(state, payload) {
        state.userAgents = state.userAgents.filter((agent) => agent.uuid !== payload.uuid);
        state.filteredUserAgents = state.filteredUserAgents.filter((agent) => agent.uuid !== payload.uuid);
    },
    setUserFavoritesTotals(state, payload) {
        state.userFavoritesTotals = payload;
    },
    updateUserFavoritesTotals(state, payload) {
        const add = payload.auth_user.is_in_favorites ? 1 : -1;
        if (state.user) {
            state.user.favorites_count += add;
        }
        if (state.userFavoritesTotals.hasOwnProperty(payload.ad_type)) {
            state.userFavoritesTotals[payload.ad_type] += add;
        }
        if (state.userFavoritesTotals.hasOwnProperty('all')) {
            state.userFavoritesTotals.all += add;
        }
    },
    addToUserAdvertsTotal(state, payload) {
        state.user.ads_count += payload;
    },
    addToUserAgentsTotal(state, payload) {
        state.user.agents_count += payload;
    },
    addToUserAdAlertsTotal(state, payload) {
        state.user.alerts_count += payload;
    },
    setUserAdAlertsTotal(state, payload) {
        state.userAdAlertsTotal = payload;
        if (state.user) {
            state.user.alerts_count = payload;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
